import { API } from "../auth/authApi";

// GET
export const getGalleryApi = (params) => {
  return API.get("/gallery/media", { params });
};

// CREATE (MULTIPLE IMAGES)
export const createGalleryApi = (data) => {
  return API.post("/gallery/media", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// DELETE
export const deleteGalleryApi = (id) => {
  return API.delete(`/gallery/media/${id}`);
};